import { render, staticRenderFns } from "./CustomerLinkModal.vue?vue&type=template&id=46020c06&scoped=true"
import script from "./CustomerLinkModal.vue?vue&type=script&lang=js"
export * from "./CustomerLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46020c06",
  null
  
)

export default component.exports